import { ReactComponent as WifiLowIcon } from "assets/svgs/network/wifi_low.svg";
import { ReactComponent as WifiMidIcon } from "assets/svgs/network/wifi_mid.svg";
import { ReactComponent as WifiHighIcon } from "assets/svgs/network/wifi_high.svg";

/** SVG root from SVGR — explicit size so icons are not collapsed in tables/flex. */
const iconFrame = "inline-block h-4 w-4 shrink-0 align-middle";

const NetworkIcon = ({ className = "", type = "", status = 100, showType = false, reverse = false }) => {
    let icon,
        typeClassName = "";
    if (status !== undefined && status > 0) {
        if (status >= 75) {
            icon = <WifiHighIcon className={`${iconFrame} text-white`} />;
            typeClassName = "text-white";
        } else if (status >= 25) {
            icon = <WifiMidIcon className={`${iconFrame} text-low`} />;
            typeClassName = "text-low";
        } else {
            icon = <WifiLowIcon className={`${iconFrame} text-warning`} />;
            typeClassName = "text-warning";
        }
    } else {
        icon = <WifiHighIcon className={`${iconFrame} text-white/50`} />;
        typeClassName = "text-white/50";
    }

    return (
        <div
            className={`flex items-center justify-center space-x-1 ${className} ${
                reverse ? "-reverse space-x-reverse" : ""
            }`}
        >
            {icon}
            {showType && <p className={`text-h5 leading-none ${typeClassName}`}>{type}</p>}
        </div>
    );
};

export default NetworkIcon;
